import React from 'react';
import { Link } from 'react-router-dom';
import { SaveButton, StringHelpers } from 'e4shared';
import { apiGet, apiPost } from '../../services';
import { setStorage } from '../../helpers/storage';

export const Join = ({ history, match }) => {
    const [guid, setGuid] = React.useState('');
    const [error, setError] = React.useState(false);
    const [password, setPassword] = React.useState('');
    const [passwordValid, setPasswordValid] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const [saving, setSaving] = React.useState(false);

    React.useEffect(() => {
        if (!match.params.guid) {
            setError('INVALID_URL');
        } else {
            setGuid(match.params.guid);
        }
    }, []);

    React.useEffect(() => {
        if (guid) {
            // check valid;
            apiGet(
                'verify-join',
                guid,
                () => {
                    setError('');
                },
                err => {
                    setError(err);
                }
            );
        }
    }, [guid]);

    React.useEffect(() => {
        const regEx = StringHelpers.regExs.PASSWORD;
        let patt = new RegExp(regEx);
        setPasswordValid(password && patt.test(password));
    }, [password]);

    const checkSubmit = (e, callback) => {
        if (e.key === 'Enter') {
            callback();
        }
    };

    const join = () => {
        passwordValid &&
            apiPost(
                `join`,
                { password },
                guid,
                response => {
                    if (response.status === 401) {
                        setError('ALREADY_SET');
                    } else {
                        setStorage('user', guid);
                        setSuccess(true);
                    }
                },
                error => {
                    console.error(error);
                    setError('ALREADY_SET');
                }
            );
    };

    const login = () => {
        history.push('/develop/performance-dashboard');
    };

    return (
        <div className="login-box">
            <div className="login-logo">
                <img alt="Richardson Sales Performance" src="/dist/img/richardson_sp.png" loading="lazy" />
            </div>
            <div className="login-body">
                {success ? (
                    <div>
                        <div className="mt10 text-center">
                            <h1 className="inline">
                                <i className="fa fa-check-circle text-success text-lg mr10" />
                            </h1>
                        </div>
                        <div className="mt10 text-center">
                            <p>Great news! Your password has been successfully updated.</p>
                            <p>Please login now to start using the site.</p>
                            <p>
                                <button onClick={login} className="btn btn-success">
                                    Login
                                </button>
                            </p>
                        </div>
                    </div>
                ) : (
                    <div>
                        {error ? (
                            <p className="error">
                                {error === 'INVALID_URL' ? (
                                    <span>The url specified is not a valid invite url.</span>
                                ) : (
                                    <span>
                                        Sorry, but this account either no longer exists or has already set their password. If
                                        you need to reset your password, please{' '}
                                        <Link to="/forgot-password">visit the forgotten password page</Link>.
                                    </span>
                                )}
                            </p>
                        ) : (
                            <span>
                                <p>Welcome!</p>
                                <p>Please enter your new password to gain access.</p>
                                <p>
                                    It must be at least 8 characters long and contain at least one uppercase letter, one
                                    lowercase letter and one number.
                                </p>
                                <div className="mb20 has-feedback">
                                    <input
                                        onChange={e => setPassword(e.target.value)}
                                        onKeyUp={e => checkSubmit(e, join)}
                                        type="password"
                                        className="form-control"
                                        placeholder="Password"
                                    />
                                    <span className="glyphicon glyphicon-lock form-control-feedback" />
                                </div>
                                <div className="flex flex-center">
                                    <div className="flex-grow">
                                        <SaveButton
                                            saving={saving}
                                            setSaving={setSaving}
                                            disabled={!passwordValid}
                                            onClick={() => join()}
                                            onKeyUp={e => checkSubmit(e, join)}
                                            className="btn btn-primary"
                                        >
                                            Save new password
                                        </SaveButton>
                                    </div>
                                </div>
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Join;
